// extracted by mini-css-extract-plugin
export default {"modal":"ChooseMethodModal_modal__YGWo1","content":"ChooseMethodModal_content__DIyvP","another-card":"ChooseMethodModal_another-card__po4gT"};